export const TICKET_MESSAGE_INCOMING_NAME = 'smsIncoming';
